/**
 * 
 * @description Regex code for validation 
 * @returns RegexExpressions
 */


export const isValid = (name) => {
    const matchString = /^[a-zA-Z ]+$/;
    return matchString.test(name);
  };
  
  export const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
  
  export const passwordError =
    "Please enter minimum 8 character password with at least 1 uppercase, one numeric digit, 1 lower case & 1 special character.";
  
  export const passRegrex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?!.* ).{8,40}$/;
  
  export const phoneRegExp = /^(\+\d{1,3}[- ]?)?\d{10}$/;

  export const emailRegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  export const zipRegExp = /[1-9]{1}[0-9]{2}[0-9]{3}$/;
  